<template>
  <div>
    <van-nav-bar title="客服反馈" left-text="返回" left-arrow @click-left="onClickLeft" />
    <div class="chatAppBody">
      <div class="chatBox">
        <!-- 用户发送的内容 -->
        <div v-for="(message, index) in messages" :key="index"
          :class="message.sender === 'customer' ? 'chatRow chatRowMe' : 'chatRow'">
          <el-avatar class="chatAvatar" :size="30" src="https://img2.baidu.com/it/u=3987897595,2066434013&fm=253&fmt=auto&app=120&f=JPEG?w=800&h=1067"
            v-if="message.sender !== 'customer'"></el-avatar>
          <div class="chatMsgContent">
            <div class="chatUsername">{{ message.sender === 'customer' ? '用户' : '实物小站客服小花' }}</div>
            <div class="chatContent">{{ message.content }}</div>
          </div>
        </div>
      </div>
      <div class="chatBottom">
        <div class="chatInputArea">
          <!-- 文本输入框 -->
          <textarea v-model="newMessage" class="chatInput" placeholder="输入消息..."></textarea>
          <!-- 发送按钮 -->
          <button class="chatSendButton" @click="sendMessage">发送</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Customer',
  data() {
    return {
      newMessage: '',
      messages: []
    };
  },
  methods: {
    onClickLeft() {
      this.$router.push('/');
    },
    sendMessage() {
      // 发送用户消息
      if (this.newMessage.trim() !== '') {
        this.messages.push({ sender: 'customer', content: this.newMessage.trim() });
        // 这里可以发送用户消息的逻辑
        // 比如，调用发送消息的接口等
        // 清空输入框
        this.newMessage = '';
        // 发送固定的回复消息
        this.sendFixedResponse();
      }
    },
    sendFixedResponse() {
      // 发送固定的回复内容
      const fixedResponse = '感谢您的反馈，我们会尽快处理。';
      this.messages.push({ sender: 'server', content: fixedResponse });
      // 这里是你发送消息的逻辑
      // 比如，调用发送消息的接口等
    }
  },
}
</script>
<style scoped>
.chatAppBody {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f1f5f8;
}

.chatTitle {
  background: #fff;
}

.chatBox {
  flex: 1;
  padding: 0 5px;
}

.chatBottom {
  background: #fff;
}

.chatRow {
  display: flex;
  align-items: flex-end;
  margin: 5px 0px;
}

.chatAvatar {
  margin-right: 5px;
  flex-shrink: 0;
}

.chatUsername {
  font-size: 12px;
  white-space: nowrap;
  color: #999;
  margin-bottom: 2px;
}

.chatContent {
  border-radius: 10px 10px 10px 0px;
  padding: 10px;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 5px 30px rgb(50 50 93 / 8%), 0 1px 3px rgb(0 0 0 / 5%);
  font-size: 14px;
  word-break: break-all;
  line-height: 21px;
}

.chatRowMe {
  justify-content: flex-end;
}

.chatRowMe .chatContent {
  border-radius: 10px 10px 0px 10px;
}

.chatInputArea {
  display: flex;
  align-items: center;
  padding: 10px;
  border-top: 1px solid #ddd;
  background-color: #f5f5f5;
}

.chatInput {
  flex: 1;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  resize: none;
  outline: none;
  font-size: 14px;
}

.chatSendButton {
  margin-left: 10px;
  padding: 5px 15px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.chatSendButton:hover {
  background-color: #45a049;
}
</style>


// WEBPACK FOOTER //
// src/components/Customer.vue